import { Box, Grid } from "@mui/material";
import { Address } from "../../services/swagger";
import AddressCard from "./AddressCard";
import FieldLabel from "../atoms/FieldLabel";
import { useTranslation } from "react-i18next";

interface AddressGridProps {
  addresses: Address[];
  onChange: (addresses: Address[]) => any;
}

export default function AddressGrid(props: AddressGridProps) {
  const { t } = useTranslation("Contact");
  return (
    <Box width={1}>
      <FieldLabel>{t("Address")}</FieldLabel>
      <Grid container spacing={2}>
        {props.addresses.map((address, i) => (
          <Grid size={{ xs: 6 }}>
            <AddressCard
              key={i}
              address={address}
              onSave={(newAddress) =>
                props.onChange([
                  ...props.addresses.slice(0, i),
                  newAddress,
                  ...props.addresses.slice(i + 1, props.addresses.length),
                ])
              }
              onDelete={() =>
                props.onChange(
                  props.addresses.filter((_, index) => index !== i),
                )
              }
            />
          </Grid>
        ))}
        <Grid size={{ xs: 6 }}>
          <AddressCard
            onSave={(newAddress) =>
              props.onChange([...props.addresses, newAddress])
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
